<script>
import IconChevronDown from '../icons/IconChevronDown';

export default {
  components: {
    IconChevronDown,
  },
  props: {
    categories: Array,
  },
};
</script>

<template lang='pug'>
.flex.items-center.w-full.mt-1_5.justify-around.header-bottom__links

  //- shop by link
  .text-xl.mr-1.relative.cursor-pointer.select-none.z-102(
    v-if='categories && categories.length',
    tabindex='0',
    @click='$emit("toggle-shop-menu", $event)',
    @keyup.enter='$emit("toggle-shop-menu", $event)',
  ) Shop By
    icon-chevron-down.ml-_5.text-brand

  //- start selling link
  router-link.text-xl.cursor-pointer.z-102(
    tabindex='0',
    tag='div',
    :to='{ name: "openShop" }',
  ) Start Selling
</template>

<style>
@import '~import/index';

</style>